module.exports = __webpack_public_path__ + "img/origin-rose.8edac3fc.svg";